import {
  parseSearchNumberValue,
  parseSearchStringValue,
} from 'infrastructure/functions/parse-query-string';
import { useQueryFilterNew } from 'infrastructure/hooks/common/use-query-param-new';
import { endOfMonth, startOfMonth } from 'date-fns';

import type { TParseFunctions } from 'infrastructure/hooks/common/use-query-param-new';
import type { Filters } from './types';

const DEFAULT_FILTERS: Filters = {
  startTime: startOfMonth(new Date()).toISOString(),
  endTime: endOfMonth(new Date()).toISOString(),
  page: 1,
  items: 100,
};

const parseFunctions: TParseFunctions<Filters> = {
  page: parseSearchNumberValue,
  startTime: parseSearchStringValue,
  endTime: parseSearchStringValue,
  phone: parseSearchStringValue,
  callId: parseSearchStringValue,
  agent: parseSearchStringValue,
};

export const useUntrackedInboundCallsFilters = () => {
  return useQueryFilterNew<Filters>(DEFAULT_FILTERS, parseFunctions, [
    'page',
    'endTime',
  ]);
};
